import delve from 'dlv'
import {
  getStaticPropsBySlug,
  getStaticPathsBySlugPrefix,
} from 'lib/staticProps'

import type { FC } from 'react'

import Head from 'next/head'
import Layout from 'components/layouts/main'
import PolicyPage from 'components/pages/policy'

interface Props {
  content: any
}

const LegalPage: FC<Props> = (props) => {
  const { content } = props
  const { title } = delve(content, 'data.attributes')

  return (
    <>
      <Head>
        <title key="title">{title}</title>
      </Head>
      <Layout>
        <PolicyPage {...props} />
      </Layout>
    </>
  )
}

export const getStaticProps = getStaticPropsBySlug('legal/', 'blocks.policy')
export const getStaticPaths = getStaticPathsBySlugPrefix('legal/')

export default LegalPage
